import axios from 'axios';
import authHeader from './auth-header';

const API_URL = `${process.env.VUE_APP_API_URL}work-center-calendar`;

class WorkCenterCalendarService {
  // eslint-disable-next-line class-methods-use-this
  getCalendarEntriesByWorkCenter(workCenterId, params) {
    return axios.get(`${API_URL}/work-center/${workCenterId}`, {
      headers: authHeader(),
      params,
    });
  }

  // eslint-disable-next-line class-methods-use-this
  createCalendarEntry(data) {
    return axios.post(`${API_URL}/`, data, { headers: authHeader() });
  }

  // eslint-disable-next-line class-methods-use-this
  updateCalendarEntry(id, data) {
    return axios.patch(`${API_URL}/${id}`, data, { headers: authHeader() });
  }

  // eslint-disable-next-line class-methods-use-this
  deleteCalendarEntry(id) {
    return axios.delete(`${API_URL}/${id}`, { headers: authHeader() });
  }

  // eslint-disable-next-line class-methods-use-this
  bulkLoadWeekends(workCenterId, year) {
    return axios.post(`${API_URL}/bulk-weekends`, null, {
      headers: authHeader(),
      params: { workCenterId, year },
    });
  }
}

export default new WorkCenterCalendarService();
